import { useRecoilValue } from 'recoil';
import { authzContextAtom } from '../../../authorization/authzState';
import { userInformationAtom } from '../../../Services/_states';
import { canCreateWorkspace } from '../utils/canCreateWorkspace';

/**
 * Resolves create-business-service permission for the active account route.
 * @param {string} accountId
 */
export default function useCanCreateWorkspace(accountId) {
  const authz = useRecoilValue(authzContextAtom);
  const userInfo = useRecoilValue(userInformationAtom);

  return canCreateWorkspace(authz, { accountId, userInfo });
}
